<template>
  <div
    class="fixed inset-y-0"
    :class="[
      uiStore.vaFilterNavDrawerOpen ? 'z-[500]' : '',
      'fixed md:translate-x-0',
      uiStore.vaFilterNavDrawerOpen && uiStore.mobile
        ? 'flex h-full w-full translate-x-0 flex-col overflow-y-auto   bg-white transition'
        : ' -translate-x-full',
    ]"
  >
    <div v-if="uiStore.mobile" class="mx-auto p-4">
      <v-btn
        class="absolute right-1 top-1"
        icon
        :color="vgOcean"
        @click.prevent.stop="setNavDrawerOpen(false)"
      >
        <fa-icon icon="fa-regular fa-xmark-large" />
      </v-btn>
    </div>
    <p v-if="uiStore.mobile" class="text-vgocean mx-4 text-center">
      <fa-icon icon="fa-regular fa-bars-filter" class="translate-y-1 text-lg" />
      <span class="text-xs font-bold uppercase"> filter results</span>
    </p>
    <VaSearchFilters v-if="uiStore.mobile" class="z-[501] px-3" />
  </div>
</template>

<script>
import { sessionUserHasPermission } from '@/services/clientSessionService';
import { mapStores } from 'pinia';
import { useUiStore } from '@/stores/ui';
import tailwind from 'tailwind.config';
import VaSearchFilters from '@/components/vaSearchFilters.vue';

export default {
  name: 'VaFilterMobileWrapper',
  components: {
    VaSearchFilters,
  },
  emits: ['setNavDrawerOpen'],
  data() {
    return {
      vgOcean: tailwind.theme.extend.colors.vgocean[500],
    };
  },
  computed: {
    ...mapStores(useUiStore),
  },
  methods: {
    sessionUserHasPermission,
    setNavDrawerOpen(status) {
      this.$emit('setNavDrawerOpen', status);
    },
  },
};
</script>
